function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFDFD;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M20,24h10c6.6,0,12,5.4,12,12v94.6C85.2,57,165.2,7.7,256.8,8C393.2,8.4,504.2,120,504,256.4 C503.8,393.2,392.8,504,256,504c-63.9,0-122.2-24.2-166.2-63.9c-5.1-4.6-5.4-12.6-0.5-17.4l7.1-7.1c4.5-4.5,11.7-4.7,16.5-0.5 c37.9,34.1,88,54.9,143.1,54.9c117.7,0,214-95.3,214-214c0-117.7-95.3-214-214-214c-82.9,0-154.7,47.1-190.3,116H164 c6.6,0,12,5.4,12,12v10c0,6.6-5.4,12-12,12H20c-6.6,0-12-5.4-12-12V36C8,29.4,13.4,24,20,24z M341.6,339.2l4.7-6.5 c3.9-5.4,2.7-12.9-2.6-16.8L272,263.9V116c0-6.6-5.4-12-12-12h-8c-6.6,0-12,5.4-12,12v164.1l84.9,61.7 C330.2,345.8,337.7,344.6,341.6,339.2L341.6,339.2z"
});

var SvgIconRecentTrades = function SvgIconRecentTrades(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconRecentTrades, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_recent_trades.7bb4116b.svg";
export { ForwardRef as ReactComponent };